<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_NAME"
    :table-columns="tableColumns"
  >
    <template #create-button>
      <b-button
        v-b-toggle.sidebar-create
        variant="primary"
        @click="create()"
      >
        {{ $t('Create') }}
      </b-button>
    </template>
    <template #create-body>
      <create @refetchData="refetchData" />
    </template>

    <template #cell(status)="{ data }">
      {{ data.value == '100' ? 'Faol' : 'Faol emas' }}
    </template>
    <!-- Column: Actions -->
    <template #cell(actions)="{ data }">

      <div class="text-nowrap">
        <feather-icon
          icon="EyeIcon"
          class="cursor-pointer mr-1"
          size="16"
          @click="$router.push({ name: 'certificate-view', params: { id: data.item.id }})"
        />
        <feather-icon
          v-if="$can('update', 'All')"
          v-b-toggle.sidebar-create
          icon="EditIcon"
          class="cursor-pointer"
          size="16"
          @click="update(data.item)"
        />

        <feather-icon
          v-if="$can('delete', 'All')"
          :id="`invoice-row-${data.item.id}-preview-icon`"
          icon="TrashIcon"
          size="16"
          class="mx-1 cursor-pointer"
          @click="remove(data.item)"
        />
      </div>
    </template>
  </l-table>

</template>

<script>
import {
  BButton, VBToggle,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import certificateModule from '@/store/certificate-lang/index'
import Create from './Create.vue'
import LTable from '@/views/components/LTable.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    LTable,
    BButton,
    Create,
  },
  methods: {
    create() {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE`, { status: '100' })
    },
    remove(data) {
      this.$removeSwal(this, data, `${this.MODULE_NAME}/del`, this.refetchData)
    },
    update(data) {
      this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
    },
    refetchData() {
      this.$refs.LTable.refetchData()
    },
  },
  setup() {
    const tableColumns = [
      { key: 'index', label: '#' },
      { key: 'uz', label: 'name uz', sortable: true },
      { key: 'ru', label: 'name ru', sortable: true },
      { key: 'en', label: 'name en', sortable: true },
      { key: 'status', label: 'Status', sortable: true },
      { key: 'actions', label: 'Actions' },
    ]
    const MODULE_NAME = 'certificate'

    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, certificateModule)

    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
    })

    return {
      MODULE_NAME,
      tableColumns,
    }
  },
}
</script>

<style lang="scss">
</style>
